import React from "react";
import * as yup from "yup";
import { useStoreActions, useStoreState } from "easy-peasy";
import api from "../../services/api";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Button, Container, Paper, Divider, FormControl } from "@mui/material";
import FileField from "../../components/FileField";

const AdminArquivos = () => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  const [doc, setDoc] = React.useState(null);
  let user = useStoreState((state) => state.auth.user);

  const schema = yup.object({
    docId: yup.number().required().nullable().label("Documento"),
  });

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
  });

  const onSave = async (data) => {
    startLoading();
    try {
      let arquivoData;
      if (data.id) {
        arquivoData = (await api.http.put("/configs", data)).data;
      } else {
        arquivoData = (await api.http.post("/configs", data)).data;
      }
      setDoc(arquivoData.doc);
      reset(arquivoData);

      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true,
    };
    if (user.roleId == "admin") loadDocumentos(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  const loadDocumentos = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get("/configs")).data;
      if (mount.isMounted) setDoc(data.doc);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  const {
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  return (
    <Container maxWidth="false">
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: "center",
          px: 4,
          pt: 2,
          pb: 3,
          m: 5,
        }}
      >
        <Divider>
          <h3>Termo de compromisso e confidencialidade</h3>
        </Divider>
        <FormControl sx={{ my: 2 }} fullWidth>
          <FileField
            field="docId"
            fileData={doc}
            useFormRef={useFormRef}
            schema={schema}
          />
        </FormControl>
        <Button
          color="primary"
          onClick={handleSubmit(onSave)}
          variant="contained"
          disabled={!isDirty || isSubmitting}
        >
          {" "}
          Alterar
        </Button>
      </Paper>
    </Container>
  );
};

export default AdminArquivos;
